import store from "./store";

class HttpRequest {
  constructor(vue) {
    this.vue = vue;
    this.cacheData = store.state.categoryMapper;
  }

  //缓存URL data
  saveUrlData(url, data) {
    this.cacheData[url] = data;
    store.state.categoryMapper = Object.assign({}, this.cacheData);
  }

  httpRequestData(url, data, suc, err, caller, cache) {
    let _withCredentials = false;

    if (window.orgUser.getPlat() === "h5") {
      let _str = "?";
      if (url.indexOf('?') > -1) {
        _str = "&"
      }
      url += _str + "cookie=1";
      _withCredentials = true;
    }
    if (this.cacheData[url]) {
      suc && suc.call(caller, this.cacheData[url]);
      return;
    }

    this.vue.$http({url, withCredentials: _withCredentials})
      .then(function (res) {
        if (parseInt(res.status) >= 0) {
          if (cache) {
            this.saveUrlData(url, res.data);
          }
          suc && suc.call(caller, res.data);
        } else {
          err && err.call(caller, res);
        }
      }.bind(this))
      .catch(function (res) {
        err && err.call(caller, res);
      })
  }

  httpRequest(url, suc, err, caller, cache = true, data = null) {
    if (window.orgUser.getPlat() === "h5") {
      let _str = "?";
      if (url.indexOf('?') > -1) {
        _str = "&"
      }
      url += _str + "cookie=1";
    }
    if (this.cacheData[url]) {
      suc && suc.call(caller, this.cacheData[url]);
      return;
    }
    this.vue.$http({url: url, data: data}).then(function (res) {
      if (parseInt(res.status) >= 0) {
        if (cache) {
          this.saveUrlData(url, res.data);
        }
        suc && suc.call(caller, res.data);
      } else {
        err && err.call(caller, res);
      }
    }.bind(this)).catch(function (res) {
      err && err.call(caller, res);
    })
  }

  httpCanvasRequest(url, data, suc, err, caller) {
    this.httpRequest(url, suc, err, caller, false, data);
  }
}

export {HttpRequest}



// WEBPACK FOOTER //
// ./src/store/HttpRequest.js